import { configureStore, combineReducers } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import logger from "redux-logger";
import programReducer from "./reducers/programsSlice";
import authReducer from "./reducers/authSlice";
import dropOutReducer from "./reducers/dropOutSlice";
import tuitionReducer from "./reducers/tuitionSlice";
import salesReducer from "./reducers/salesSlice";
import profitLossReducer from "./reducers/profitLossSlice";
import userReducer from "./reducers/userSlice";
import syncReducer from './reducers/syncSlice';
import yearManagementReducer from './reducers/yearManagementSlice';
import pricingReducer from './reducers/pricingSlice';
import trialReducer from './reducers/trialSlice';

const sagaMiddleware = createSagaMiddleware();

const reducer = combineReducers({
  programs: programReducer,
  auth: authReducer,
  dropouts: dropOutReducer,
  tuition: tuitionReducer,
  sales: salesReducer,
  profitLoss: profitLossReducer,
  users: userReducer,
  sync: syncReducer,
  yearManagement: yearManagementReducer,
  pricing: pricingReducer,
  trial: trialReducer,
});

const store = configureStore({
  reducer,
  middleware: (getDefaultMiddleware) => 
    // getDefaultMiddleware().concat(sagaMiddleware, logger), // Correctly set up middleware
    getDefaultMiddleware().concat(sagaMiddleware), // Correctly set up middleware
});

export default store;
